import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const LaborActiveBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-amber-500 font-semibold text-white">
      {t('component:badge.activePhase')}
    </Badge>
  );
};
